import type { IconDefinition } from '../../types'

export default {
  details: [32, 32, [], '', 'M2 3C2 2.5 2.4375 2 3 2H11C11.5 2 12 2.5 12 3C12 3.5625 11.5 4 11 4H8V14C8 18.4375 11.5625 22 16 22C20.375 22 24 18.4375 24 14V4H21C20.4375 4 20 3.5625 20 3C20 2.5 20.4375 2 21 2H29C29.5 2 30 2.5 30 3C30 3.5625 29.5 4 29 4H26V14C26 19.5625 21.5 24 16 24C10.4375 24 6 19.5625 6 14V4H3C2.4375 4 2 3.5625 2 3ZM2 29C2 28.5 2.4375 28 3 28H29C29.5 28 30 28.5 30 29C30 29.5625 29.5 30 29 30H3C2.4375 30 2 29.5625 2 29Z'],
  name: 'uiUnderline'
} as IconDefinition
